// ==============================|| OVERRIDES - CARD ||============================== //

export default function Card(theme) {
    return {
        MuiCard: {
            defaultProps: {
                elevation: 0,
            },
        }
    };
}